<template>
    <v-btn
        dark
        depressed
        outlined
        class="body-1 px-10 test-white caption main--yellow"
        :to="to"
        :width="width"
        @click="$emit('click', $event)"
    >
        {{ text }}
    </v-btn>
</template>

<script>
    export default {
        name: 'HomeButton',
        props: {
            text: {
                required: true,
                type: String,
            },
            to: {
                required: false,
                type: String,
                default: '',
            },
            width: {
                required: false,
                type: String,
                default: '',
            }
        }
    }
</script>

<style scoped>

</style>
